import { render, staticRenderFns } from "./CampaignsTable.vue?vue&type=template&id=7fa4ad70&"
import script from "./CampaignsTable.vue?vue&type=script&lang=js&"
export * from "./CampaignsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports